export default __webpack_public_path__ + "static/media/detail_mobile_13_4.6aa6e2b2.jpg";